import React, { useEffect, useRef } from 'react';
import { Button, notification } from 'antd';
import { SmileOutlined } from '@ant-design/icons';
import { subscribeToPushNotifications } from "../UserLogin/actions";
import { getAuthToken } from "../UserLogin/reducer";
import { useDispatch, useSelector } from "react-redux";
import { getTypeExhibition } from "../../views/Home/reducer";
import {getLanguage} from "../LanguageModal/reducer";
import translations from "../LanguageModal/translations";

export const useNotification = () => {
    const dispatch = useDispatch();
    const [api, contextHolder] = notification.useNotification();
    const token = useSelector(state => getAuthToken(state.userLogin));
    const typeExhibition = useSelector(state => getTypeExhibition(state.exhibition));
    const notificationShown = useRef(false);

    const language = useSelector(getLanguage);
    const languageString = language[0]+language[1];
    const t = (key) => {
        const languageString = language[0]+language[1];
        const translation = translations[languageString];
        return translation ? translation[key] || key : key;
    };

    const dataExhibition = {
        asia: { color: '#B10000' },
        gras: { color: '#037C00' }
    };

    const shouldShowNotification = () => {
        if (!token) return false;

        const notificationSettings = JSON.parse(localStorage.getItem('notificationSettings') || '{}');

        // Если уведомление уже показано в текущей сессии
        if (notificationShown.current) return false;

        // Проверяем, не отложено ли уведомление
        if (notificationSettings.delayUntil) {
            return Date.now() > notificationSettings.delayUntil;
        }

        return true;
    };

    const showNotification = (placement) => {
        if (!shouldShowNotification()) return;

        const key = `notification-${Date.now()}`;
        notificationShown.current = true;

        api.info({
            key,
            message: t('notif'),
            description: t('allowSending'),
            placement,
            icon: <SmileOutlined style={{ color: dataExhibition[typeExhibition]?.color }} />,
            duration: 0,
            btn: (
                <div>
                    <Button
                        type="primary"
                        size="small"
                        onClick={() => {
                            api.destroy(key);
                            dispatch(subscribeToPushNotifications(token));
                            localStorage.setItem('notificationSettings', JSON.stringify({
                                allowed: true,
                                lastShown: Date.now()
                            }));
                        }}
                        style={{ fontWeight: 'bold' }}
                    >
                        {t('allow')}
                    </Button>
                    <Button
                        type="default"
                        size="small"
                        onClick={() => {
                            api.destroy(key);
                            localStorage.setItem('notificationSettings', JSON.stringify({
                                delayUntil: Date.now() + 24 * 60 * 60 * 1000, // Откладываем на 24 часа
                                lastShown: Date.now()
                            }));
                        }}
                        style={{ marginLeft: 8 }}
                    >
                        {t('remindMe')}
                    </Button>
                </div>
            ),
        });
    };

    useEffect(() => {
        const checkPushSubscription = async () => {
            if ('serviceWorker' in navigator && 'PushManager' in window) {
                try {
                    const registration = await navigator.serviceWorker.ready;
                    const subscription = await registration.pushManager.getSubscription();

                    if (!subscription && shouldShowNotification()) {
                        const timer = setTimeout(() => {
                            showNotification('topRight');
                        }, 3000);

                        return () => clearTimeout(timer);
                    }
                } catch (error) {
                    console.error('Ошибка проверки подписки:', error);
                }
            }
        };

        checkPushSubscription();
    }, []);

    return { contextHolder };
};
